import { useEffect, useState } from "react";
import InputAHSF from "../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import ButtonAHSF from "../../../Components/ButtonAHSF";

import Swal from "sweetalert2";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import {
  AddProjectExtensionRequestDetails,
  GetProjectExtensionRequestDetailsById,
  UpdateProjectExtensionRequestDetails,
} from "../../../Redux/Reducers/ReportStage/ProjectExtensionRequestDetails";

const ProjectExtensionRequestDetailsForm = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const GetProjectExtensionRequestDetails = useSelector(
    (state) =>
      state.ProjectExtensionRequestDetails.ProjectExtensionRequestDetails
  );

  console.log(GetProjectExtensionRequestDetails, "dssdsd");

  const userInfo = useSelector((state) => state.UserInfo.UserInfo);
  console.log(userInfo.userToken.userGuid, "userInfo");

  const [NumberOfMonth, setNumberOfMonth] = useState("");
  const [NumberOfMonthValidation, setNumberOfMonthValidation] = useState(false);

  // Fetch existing activity on edit

  useEffect(() => {
    if (props.Action === "edit") {
      dispatch(
        GetProjectExtensionRequestDetailsById({
          projectExtensionRequestDetailsId:
            props.projectExtensionRequestDetailsId,
        })
      );
    }
  }, [props.Action, props.projectExtensionRequestDetailsId]);

  // Set state from store in edit mode
  useEffect(() => {
    if (props.Action === "edit" && GetProjectExtensionRequestDetails) {
      setNumberOfMonth(
        GetProjectExtensionRequestDetails.numberMonthsRequestedForExtension ||
          ""
      );
    }
  }, [props.Action, GetProjectExtensionRequestDetails]);

  const Validation = () => {
    const isEmpty = !NumberOfMonth || NumberOfMonth.trim() === "";
    setNumberOfMonthValidation(isEmpty);
    return !isEmpty;
  };

  const Add = () => {
    if (Validation()) {
      dispatch(
        AddProjectExtensionRequestDetails({
          numberMonthsRequestedForExtension: NumberOfMonth.trim(),
          projectModificationRequestsId: props.projectModificationRequestsId,
        })
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تمت الأضافة بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      $(".close-btn").trigger("click");
    }
  };

  const Edit = () => {
    if (Validation()) {
      dispatch(
        UpdateProjectExtensionRequestDetails({
          projectExtensionRequestDetailsId:
            props.projectExtensionRequestDetailsId,
          numberMonthsRequestedForExtension: NumberOfMonth.trim(),
          projectModificationRequestsId: props.projectModificationRequestsId,
        })
      );

      Swal.fire({
        position: "center",
        icon: "success",
        title: "تم التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
      });

      $(".close-btn").trigger("click");
      navigate(""); // Optional: replace with actual route
    }
  };

  const renderForm = () => (
    <>
      <InputAHSF
        fieldsName="NumberOfMonthsRequiredForExtension"
        show={true}
        type={"number"}
        disabled={props.shouldDisableFields}
        defaultValue={
          props.Action == "edit"
            ? GetProjectExtensionRequestDetails?.numberMonthsRequestedForExtension
            : ""
        }
        onChange={(e) => setNumberOfMonth(e.target.value)}
        showValidationMessage={NumberOfMonthValidation}
        validationMessage="حقل إجباري"
      />

      <div className="ConainerButtonAHSF">
        <ButtonAHSF
          onClick={props.Action === "edit" ? Edit : Add}
          text="حفظ"
          show={true}
        />
      </div>
    </>
  );

  return (
    <>
      {props.Action === "edit"
        ? GetProjectExtensionRequestDetails?.projectExtensionRequestDetailsId
          ? renderForm()
          : null
        : renderForm()}
    </>
  );
};

export default ProjectExtensionRequestDetailsForm;
